// extracted by mini-css-extract-plugin
export default {"Outer":"Title_Outer__JtT7-","HasSubTitle":"Title_HasSubTitle__fXFkZ","SubTitle":"Title_SubTitle__cIFJm"};